'use client';

import { PollingVelocityClientAccountSubscriber } from '@velocity-exchange/sdk';
import { useEffect, useRef } from 'react';
import Env from 'src/environmentVariables/EnvironmentVariables';
import useVelocityClient from './useVelocityClient';
import useVelocityClientIsReady from './useVelocityClientIsReady';
import useIdleLevels from './utils/useIdleLevels';
import useVelocityStore from '../stores/VelocityStore/useVelocityStore';
import { usePageVisibility } from './utils/usePageVisibility';

const BASE_POLLING_RATE = Env.pollingFrequencyMs;
const IDLE_1_MIN_POLLING_MULTIPLIER = 10;
const IDLE_10_MIN_POLLING_MULTIPLIER = 60;

/**
 * Switches the polling rate of the bulkAccountLoader based on idle time of the user
 */
const useIdlePollingRateSwitcher = () => {
	const { idle1Min, idle10Min } = useIdleLevels();
	const pageIsVisible = usePageVisibility();

	const wasIdle = useRef(false);
	const velocityClient = useVelocityClient();
	const velocityClientIsReady = useVelocityClientIsReady();
	const setVelocityStore = useVelocityStore((s) => s.set);

	useEffect(() => {
		if (!velocityClientIsReady) return;

		if (window.localStorage.getItem('disableIdle')) {
			console.log(`Idle Polling Switcher Disabled`);
			return;
		}

		if (
			velocityClient?.accountSubscriber instanceof
			PollingVelocityClientAccountSubscriber
		) {
			if (idle10Min && !pageIsVisible) {
				wasIdle.current = true;
				console.log(`Idle => 10 Min`);
				velocityClient.accountSubscriber.updateAccountLoaderPollingFrequency(
					IDLE_10_MIN_POLLING_MULTIPLIER * BASE_POLLING_RATE
				);
				setVelocityStore((s) => {
					s.pollingMultiplier = IDLE_10_MIN_POLLING_MULTIPLIER;
				});
			} else if (idle1Min && !pageIsVisible) {
				wasIdle.current = true;
				console.log(`Idle => 1 Min`);
				velocityClient.accountSubscriber.updateAccountLoaderPollingFrequency(
					IDLE_1_MIN_POLLING_MULTIPLIER * BASE_POLLING_RATE
				);
				setVelocityStore((s) => {
					s.pollingMultiplier = IDLE_1_MIN_POLLING_MULTIPLIER;
				});
			} else if (wasIdle.current) {
				wasIdle.current = false;
				console.log(`Idle ==> false`);
				velocityClient.accountSubscriber.updateAccountLoaderPollingFrequency(
					BASE_POLLING_RATE
				);
				setVelocityStore((s) => {
					s.pollingMultiplier = 1;
				});
			}
		}
	}, [idle1Min, idle10Min, pageIsVisible, velocityClientIsReady]);
};

export default useIdlePollingRateSwitcher;
